export const baseUrl = '/mall2/?/';


// WEBPACK FOOTER //
// ./src/utils/baseUrl.js